import React from "react";
import CustomSkeletonTable from "../../ui/CustomSkeletonTable/CustomSkeletonTable";
import MerchantTableTanstack from "../tables/MerchantTableTanstack";
import MerchantEmptyState from "./MerchantEmptyState";

const MerchantTableContent = ({
  loadingData,
  noMerchants,
  noResults,
  filteredMerchants,
  onEdit,
  onToggleStatus,
  onMobileMoneyAdd,
  loadingIds,
}) => {
  if (loadingData) {
    return <CustomSkeletonTable columns={[1, 2, 3, 4, 5]} rowCount={10} />;
  }

  if (noMerchants || noResults) {
    return <MerchantEmptyState noMerchants={noMerchants} noResults={noResults} />;
  }

  return (
    <MerchantTableTanstack
      data={filteredMerchants}
      onEdit={onEdit}
      onToggleStatus={onToggleStatus}
      onMobileMoneyAdd={onMobileMoneyAdd}
      loadingIds={loadingIds}
    />
  );
};

export default MerchantTableContent;
